import {fire} from "../../fire";
import {doc, writeBatch} from 'firebase/firestore'

export const guardarDocArr = ({col, arrObj}) => {

    let batch = writeBatch(fire)

    let arrId = []
    for (let i = 0; i < arrObj.length; i++) {
        let obj = arrObj[i]

        if (!obj.id) {
            let id = new Date().getTime() + col.substr(col.length - 3, col.length).toUpperCase();
            obj.id = id;
        }

        arrId.push(obj.id)
        const referencia = doc(fire, col, obj.id);
        batch.set(referencia, obj)

    }


    return new Promise(resolve => {
        batch.commit().then((dox) => {
            return resolve({res: true, data: arrId})
        }).catch((err) => {
            //  alert(err.message)
            return resolve({res: false, data: err.message})
        })
    })


}